import {
  Box,
  Typography,
  styled,
  useTheme,
  Grid,
  Checkbox,
  Button,
  useMediaQuery,
} from '@mui/material';

// Styled components for the Stepper page
export const StepperPageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.secondary.paper,
}));

export const StepperContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 'calc(100vh - 80px)',
  padding: theme.spacing(6),
  maxWidth: '800px',
  margin: '0 auto',

  [theme.breakpoints.down('xl')]: {
    padding: theme.spacing(5),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 3, 2),
    // maxWidth: '100%',
  },
}));

export const FieldLabel = styled(Typography)(({ theme, disabled }) => ({
  fontSize: `${theme.spacing(3.5)} !important`,
  fontWeight: 400,
  marginBottom: theme.spacing(2),

  ...(disabled && {
    color: theme.palette.primary.primary_95,
  }),

  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(3.25)} !important`,
  },
}));

export const InputRow = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(8),

  [theme.breakpoints.down('xl')]: {
    marginBottom: theme.spacing(7.25),
  },

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(4),
  },
}));

export const UserTypeInputRow = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(10),

  [theme.breakpoints.down('xl')]: {
    marginBottom: theme.spacing(7.25),
  },

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(4),
  },
}));

export const StepBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(207),
  padding: theme.spacing(12),
  marginBottom: theme.spacing(6),
  borderRadius: theme.spacing(4),
  border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.secondary.neutral_30 : theme.palette.secondary.neutral_90}`,
  position: 'relative',

  [theme.breakpoints.down('xl')]: {
    marginBottom: theme.spacing(4),
  },
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(9),
  },

  [theme.breakpoints.down('md')]: {
    width: theme.spacing(140),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 3),
    width: 'calc(100vw - 24px)',
  },
}));

export const MagAPILogo = styled('img')(({ theme }) => ({
  width: theme.spacing(61),
  marginBottom: theme.spacing(9),

  [theme.breakpoints.down('xl')]: {
    width: theme.spacing(55),
    marginBottom: theme.spacing(7),
  },
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(30),
    marginBottom: theme.spacing(4),
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(5)} !important`,
  fontWeight: 500,
  marginBottom: theme.spacing(9),

  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(4.5)} !important`,
    marginBottom: theme.spacing(7),
  },

  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    fontSize: `${theme.spacing(3)} !important`,
    fontWeight: 600,
    marginBottom: theme.spacing(5),
  },

  [theme.breakpoints.down('sm')]: {
    // padding: `0 ${theme.spacing(2)}`
    width: '90%',
    lineHeight: theme.spacing(5),
  },
}));

export const StepTitle = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(7)} !important`,
  fontWeight: 600,
  marginBottom: theme.spacing(10),
  textAlign: 'center',

  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(6.25)} !important`,
    marginBottom: theme.spacing(10),
  },

  [theme.breakpoints.down('lg')]: {
    fontSize: `${theme.spacing(6)} !important`,
    marginBottom: theme.spacing(9),
  },

  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(4.5)} !important`,
    marginBottom: theme.spacing(7),
    fontWeight: 500,
  },
  [theme.breakpoints.down('sm')]: {
    // padding: `0 ${theme.spacing(2)}`
    // width: '80%',
    margin: `0 auto ${theme.spacing(7)}`,
  },
}));

export const StepSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(7)} !important`,
  fontWeight: 600,
  marginBottom: theme.spacing(12),
  marginTop: theme.spacing(-2.5),
  textAlign: 'center',

  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(6.25)} !important`,
    marginBottom: theme.spacing(10),
    marginTop: theme.spacing(-0.5),
  },

  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(4.5)} !important`,
    marginBottom: theme.spacing(7),
    marginTop: theme.spacing(-6),
    fontWeight: 500,
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: theme.spacing(8),
  },
}));

export const StepTwoInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  gap: theme.spacing(1),
}));

export const StepTwoInfoText = styled(Box)(({ theme }) => ({
  fontSize: theme.spacing(3.5),
  color: '#929094',

  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3),
  },
}));

export const BackButton = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(8),
  left: theme.spacing(8),
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    opacity: 0.8,
  },

  [theme.breakpoints.down('md')]: {
    top: theme.spacing(8.5),
    left: theme.spacing(5.5),
  },

  [theme.breakpoints.down('sm')]: {
    top: theme.spacing(5.75),
    left: theme.spacing(4.5),
  },
}));

export const BackText = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(4),
  color: '#929094',

  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3),
  },
}));

export const DoneBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  backgroundColor: '#DAEEE0',
  width: theme.spacing(100),
  padding: theme.spacing(2, 3),
  borderRadius: theme.spacing(1.25),
  margin: `0 auto ${theme.spacing(10)}`,
  color: '#389355',
  fontSize: theme.spacing(5),
  fontWeight: 500,

  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3.5),
    fontWeight: 400,
    width: theme.spacing(51),
    padding: theme.spacing(2, 3),
    margin: `${theme.spacing(7)} auto ${theme.spacing(7)}`,
  },
}));

export const EmailVerifiedBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  backgroundColor: '#DAEEE0',
  width: theme.spacing(128),
  padding: theme.spacing(2, 3),
  borderRadius: theme.spacing(1.25),
  margin: `0 auto ${theme.spacing(10)}`,
  color: '#389355',
  fontSize: theme.spacing(5),
  fontWeight: 500,

  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3.5),
    fontWeight: 400,
    width: theme.spacing(68.75),
    padding: theme.spacing(2, 3),
    margin: `${theme.spacing(0)} auto ${theme.spacing(6)}`,
  },
}));

export const BenefitsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItem: 'center',
  backgroundColor: '#F5F5F5',
  padding: theme.spacing(4, 5),
  borderRadius: theme.spacing(2),

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 4, 0),
    flexDirection: 'column',
  },
}));

export const BenefitsRowItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItem: 'center',
  gap: theme.spacing(3),
  fontSize: theme.spacing(4),

  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(4),
    // flexDirection: 'column',
  },
}));

export const BenefitsRowItemTick = styled('img')(({ theme }) => ({
  width: theme.spacing(4),
}));

export const StepContentWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(10),

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(7),
  },
}));

export const RadioGroupContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
}));

export const RadioOption = styled(Box)(({ theme, selected, disabled }) => ({
  flex: 1,
  minWidth: theme.spacing(15),
  textAlign: 'center',
  padding: theme.spacing(3, 2),
  marginRight: theme.spacing(2),
  borderRadius: theme.spacing(2),
  border: `1px solid ${selected ? '#0486D7' : disabled ? '#D0D0D0' : '#C8C5CA'}`,
  backgroundColor: selected ? '#E5F5FF' : 'transparent',
  cursor: disabled ? 'not-allowed' : 'pointer',
  position: 'relative',
  // Remove touch highlight on mobile devices
  WebkitTapHighlightColor: 'transparent',
  // Disable ripple effect if using MUI button-like behavior
  '&:active': {
    backgroundColor: disabled
      ? 'transparent'
      : selected
        ? '#E5F5FF'
        : 'transparent',
  },
  '&:last-child': {
    marginRight: 0,
  },
  // Apply hover styles only for non-touch devices and when not disabled
  '@media (hover: hover)': {
    '&:hover': {
      borderColor: disabled ? '#D0D0D0' : '#0486D7',
      backgroundColor: disabled ? 'transparent' : '#E5F5FF',
    },
  },
  // Instead of using pointerEvents: none, we'll use a different approach
  // to make it unclickable but still show the cursor
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2),
    width: '48%',
    flex: 'unset',
    padding: theme.spacing(2.75, 1),
    marginRight: theme.spacing(1),
  },
}));

export const UserTypeRadioGroupContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(-4),
  gap: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(-1),
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}));

export const UserTypeRadioOption = styled(Box)(({ theme, selected }) => ({
  flex: 1,
  minWidth: theme.spacing(15),
  textAlign: 'center',
  padding: theme.spacing(3, 2),
  // marginRight: theme.spacing(4.5),
  borderRadius: theme.spacing(2),
  border: `1px solid ${selected ? '#0486D7' : '#C8C5CA'}`,
  backgroundColor: selected ? '#E5F5FF' : 'transparent',
  cursor: 'pointer',
  position: 'relative',
  // Remove touch highlight on mobile devices
  WebkitTapHighlightColor: 'transparent',
  // Disable ripple effect if using MUI button-like behavior
  '&:active': {
    backgroundColor: selected ? '#E5F5FF' : 'transparent',
  },
  '&:last-child': {
    marginRight: 0,
  },
  // Apply hover styles only for non-touch devices
  '@media (hover: hover)': {
    '&:hover': {
      borderColor: '#0486D7',
      backgroundColor: '#E5F5FF',
    },
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2.75, 1),
    marginRight: theme.spacing(0),
    margin: 0,
    minWidth: 'auto',
    // Adjust width as needed for your layout
    width: 'calc(50% - 4px)', // 50% width minus half the gap to maintain 8px gap
  },
}));

export const UserTypeOptionText = styled(Typography)(({ theme, selected }) => ({
  fontSize: theme.spacing(4),
  color: selected ? '#1B1B1F' : '#929094',

  // [theme.breakpoints.down('md')]: {
  //   fontSize: theme.spacing(3),
  // },
}));

export const CheckboxOption = styled(Box)(({ theme, selected }) => ({
  textAlign: 'center',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  border: `1px solid ${selected ? '#0486D7' : '#E5E1E6'}`,
  backgroundColor: selected ? '#E5F5FF' : 'transparent',
  cursor: 'pointer',
  marginBottom: theme.spacing(2),
  height: '100%',
  display: 'flex',
  // flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.2s ease',
  gap: theme.spacing(2),
  '&:hover': {
    borderColor: '#0486D7',
    backgroundColor: 'rgba(229, 245, 255, 0.5)',
  },

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1.5, 1.5),
    gap: theme.spacing(1.5),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5, 4),
    gap: theme.spacing(5),
  },
}));

export const OptionText = styled(Typography)(
  ({ theme, selected, disabled }) => ({
    fontSize: theme.spacing(3.5),
    color: selected ? '#1B1B1F' : disabled ? '#D0D0D0' : '#929094',

    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(3),
    },
  })
);

export const CheckboxOptionText = styled(Typography)(({ theme, selected }) => ({
  fontSize: theme.spacing(4),
  color: selected ? '#1B1B1F' : '#929094',

  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(3.25),
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(3.5),
  },
}));

export const HiddenCheckbox = styled(Checkbox)(({ theme }) => ({
  position: 'absolute',
  opacity: 0,
  height: 0,
  width: 0,
}));
